import { Serializer } from "survey-core";

/**
 * Registers base custom SurveyJS properties used across
 * both the Creator and Renderer.
 *
 * Note: Custom question types (like appointmentsetting) are now
 * registered via customQuestionsRegistry.js for better scalability.
 */
export function registerCustomProperties() {
  // 1. Change survey title placeholder from "Survey Title" to "Form Title"
  const surveyTitleProperty = Serializer.findProperty("survey", "title");
  if (surveyTitleProperty) {
    surveyTitleProperty.placeholder = "Form Title";
  }

  // // 2. Add the customCssClass property for text questions
  // if (!Serializer.findProperty("text", "customCssClass")) {
  //   Serializer.addProperty("text", {
  //     name: "customCssClass:string",
  //     category: "general",
  //   });
  // }

  // // 3. Add the crmField property for all questions
  // if (!Serializer.findProperty("question", "crmField")) {
  //   Serializer.addProperty("question", {
  //     name: "crmField:string",
  //     category: "data",
  //     visible: true,
  //     default: "",
  //     choices: ["", "First Name", "Last Name", "Email", "Phone"],
  //   });
  // }
}
